define(function (require) {

    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var _ = require('underscore');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpSecureFormsController = require('web-agent-assets-js/lpSecureFormsController');
    var MessagingUtils = require('web-agent-utils/MessagingUtils');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');

    var MESSAGE_STATES_LEVELS = {
        SENT: 0,
        ACCEPT: 1,
        READ: 2,
        VIEWED: 3,
        ERROR: 4,
        NACK: 5
    };

    var SOURCES = {
        FACEBOOK: "FACEBOOK",
        APP: "APP",
        SMS: "SMS",
        AGENT: "AGENT",
        WEB: "WEB",
        SHARK: "SHARK",
        CUSTOM: "CUSTOM",
        NA: "NA",
        SHARK_C4M: "Shark-C4M",
        GOOGLE: "Google",
        APPLE: "Apple Business Chat",
        LINE: "LINE",
        WHATSAPP: "WhatsApp",
        WHATSAPP_BUSINESS: "WhatsApp Business",
        RCS_BUSINESS_MESSAGING: "RCS Business Messaging",
        WHC: "WHC",
        WE_CHAT: "WeChat",
        PLUSMESSAGE: "+Message"
    };

    var lpMessagingEngagementHistoryTransformationHelper = {
        getOriginatorName: getOriginatorName,
        getOriginContext: getOriginContext,
        getTranscript: getTranscript,
        getAgentName: getAgentName,
        getConsumerObject: getConsumerObject,
        transformConsumerNameBySDEs: transformConsumerNameBySDEs,
        getAssignedAgent: getAssignedAgent,
        getSuggestedAgent: getSuggestedAgent,
        getSatisfactionSurvey: getSatisfactionSurvey,
        getAgentSummary: getAgentSummary,
        normalizeAgentsParticipantsList : normalizeAgentsParticipantsList,
        transformObjectToCampaignInfo: transformObjectToCampaignInfo
    };

    /**
     * transforms the campaign data from the history to the sdk convention
     * @param {Object} obj
     */
    function transformObjectToCampaignInfo(obj) {
        if (!obj) {
            return obj;
        }

        function returnIfValid(obj) {
            return obj !== 'NA' ? obj:'';
        }


        function formatSource(sourceText, applicationName) {
            var formatedSource = '';
            if (sourceText === 'APP_INST' && applicationName) {
                formatedSource = applicationName;
            }
            else if (sourceText !== 'NA' && sourceText !== 'APP_INST') {
                formatedSource = MessagingUtils.getEngagementSourceByKey(sourceText);
            }
            return formatedSource;
        }

        return {
            visitorProfile: {
                id: obj.visitorProfileId,
                name: obj.profileSystemDefault ? agentLEManager.translateLE('LEWebAgent.visitorProfile.default.name') : returnIfValid(obj.visitorProfileName),
                description: obj.visitorProfileDescription
            },
            engagement: {
                id: obj.campaignEngagementId,
                name: returnIfValid(obj.campaignEngagementName),
                agentNote: returnIfValid(obj.engagementAgentNote),
                source: { name: formatSource(obj.engagementSource, obj.engagementApplicationName) },
                skillId: obj.engagementSkillId,
                skillName: returnIfValid(obj.engagementSkillName),
            },
            lob: {
                id: obj.lobId,
                name: returnIfValid(obj.lobName),
                description: obj.lobDescription
            },
            campaign: {
                id: obj.campaignId,
                name: returnIfValid(obj.campaignName),
                description: obj.description
            },
            visitorBehavior: {
                id: obj.visitorBehaviorId,
                name: obj.behaviorSystemDefault ? agentLEManager.translateLE('LEWebAgent.visitorBehavior.default.name') : returnIfValid(obj.visitorBehaviorName),
                description: obj.visitorBehaviorDescription
            },
            goal: {
                id: obj.goalId,
                name: returnIfValid(obj.goalName),
                description: obj.goalDescription
            },
            location: {
                id: obj.locationId,
                name: returnIfValid(obj.locationName)
            },
            source: {
                name: formatSource(obj.engagementSource, obj.engagementApplicationName)
            }
        };
    }

    /**
     * Engagement history is aggregating all the events into the agents, so we may get a duplicate state on the agents.
     * the purpose of this function is to reduce it to the last data we know about the agent.
     * @param recordData - one conversation record from the INCA list.
     */
    function normalizeAgentsParticipantsList(recordData){
        var convId = recordData.info.conversationId;
        var participantsDictionary = {};

        if(recordData && recordData.agentParticipants){
            while(recordData.agentParticipants.length){
                var agentRecord = getAgentData(recordData.agentParticipants.shift(), recordData.info.brandId);
                if (!participantsDictionary[agentRecord.dialogId || convId]) {
                    participantsDictionary[agentRecord.dialogId || convId] = {};
                }
                participantsDictionary[agentRecord.dialogId || convId][agentRecord.agentId] = agentRecord;
            }
        }
        recordData.agentParticipants = participantsDictionary;
    }

    function getAgentData(agent, brandId) {
        agent.type = agent.role;
        agent.role = agent.permission;
        agent.name = getAgentName(agent);
        agent.messagingUserId = brandId + '.' + agent.agentId;
        return agent;
    }

    function getOriginatorName(recordData, source, originatorId) {
        var name = source;
        switch (source) {
            case "visitor":
                if (recordData.consumerParticipants) {
                    var consumerProfile = _.find(recordData.consumerParticipants, function (item) {
                        return item.participantId === originatorId;
                    });
                    if (consumerProfile) {
                        return consumerProfile.consumerName || '';
                    }
                }
                break;
            case "agent":
                var agent = getAgentProfile(originatorId, recordData);
                if (agent) {
                    return agent.name;
                }
                break;
            case "system":
                name = agentLEManager.translateLE("LEWebAgent.autoMessageBotDefaultName");
                break;
        }
        return name;
    }

    function getTranscript(recordData, dialogs) {
        var transcriptStatusDictionary = getStatusDictionary();
        var transcriptActionDictionary = getActionDictionary();
        var lines = _.map(recordData && recordData.messageRecords, function (line) {
            return getLine(line);
        });

        var knownDialogsIds = getDialogIds();
        return _.filter(lines, function (line) { // return only the lines of known dialogs
            return !!_.find(knownDialogsIds, function (knownDialogId) { return knownDialogId === line.dialogId; } );
        });


        function getDialogIds() {
            var idsArray = [];
            if (_.isEmpty(dialogs)) {
                idsArray.push(recordData.info.conversationId);
            } else {
                _.each(dialogs, function (dialog) {
                    idsArray.push(dialog.dialogId);
                });
            }
            return idsArray;
        }

        function getLine(lData) {
            var source = getSource(lData, recordData);
            var originatorId = getOriginatorId(lData.participantId, source);
            var contentType = getContentType(lData.type);
            var by = getOriginatorName(recordData, source, lData.participantId);
            var text = (lData.messageData && lData.messageData.msg && lData.messageData.msg.text) || (lData.messageData && lData.messageData.file && lData.messageData.file.caption) || "";
            var quickReplies = lData.messageData && lData.messageData.quickReplies && lData.messageData.quickReplies.content;
            var fileInfo = (lData.messageData && lData.messageData.file) || (lData.messageData && lData.messageData.secureForm) || "";
            var dialogId = (lData.dialogId && lData.dialogId !== "undefined") ? lData.dialogId : recordData.info.conversationId; // because Inca stupid API (sends "undefined" as String);
            var lineKey = dialogId + ':' + lData.seq;
            var status = transcriptStatusDictionary[lineKey];
            var lineParticipantAction = transcriptActionDictionary[lineKey];

            var response = {
                by: by,
                contentType: contentType,
                conversationId: recordData.info.conversationId,
                latestAgentId: recordData.info.latestAgentId,
                dialogId: dialogId,
                sequence: lData.seq,
                sequenceId: lData.seq,
                id: lineKey,
                originatorId: originatorId,
                source: source,
                serverTimestamp: lData.timeL,
                time: lData.timeL,
                text: text,
                quickReplies: quickReplies,
                status: status,
                lineParticipantAction: lineParticipantAction,
                event:{message:fileInfo},
                isHistory:true
            };

            if (response.source === 'agent') {
                response.agentDeleted = getAgentDeleted(lData, recordData);
            }

            if(contentType === "forms/secure-invitation") {
                buildInvitationSecureFormEvent(fileInfo, response);
                buildInvitationSecureFormLine(fileInfo, response);
            }
            else if(contentType === "forms/secure-submission") {
                buildSubmitSecureFormEvent(fileInfo);
                buildSubmitSecureFormLine(fileInfo, response);
            }
            else if(contentType === "richContent") {
                delete response.text;
                response.type = contentType;
                response.json = lData.messageData && lData.messageData.richContent && lData.messageData.richContent.content;
            }
            else if (contentType === "hosted/file") {
                response.fileType = MessagingUtils.getParentFileType(response.event.message.fileType);
                if (response.fileType === lpAMSController.FILE_TYPES.AUDIO){
                    response.isAudio = true;
                } else {
                    response.isImage = true;
                }
            }

            return response;

            // function getLineStatus(lineSeq) {
            //     var lastStatusForSequence = _.last(recordData.messageStatuses, function (item) {
            //         var seq = item.messageId.split(':').pop();
            //         return lineSeq === lData.seq;
            //     });
            //
            //     if (lastStatusForSequence && lastStatusForSequence.messageDeliveryStatus) {
            //         return lastStatusForSequence.messageDeliveryStatus;
            //     }
            // }
        }

        function buildInvitationSecureFormEvent(fileInfo, response) {
            var data = {
                events: [
                    {
                        subType: lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM,
                        command: lpSecureFormsController.EVENT_TYPES.SEND,
                        args: {
                            secureFormId: fileInfo.formId,
                            secureFormName: fileInfo.formName,
                            uniqueId: fileInfo.invitationId,
                            repId: getRepId(),
                            chatId: response.conversationId
                        },
                        sequenceId: response.id
                    }
                ],
                chatId: response.conversationId
            };

            lpTag.WebAgent.secureFormsController.onCollaborationEventHandler(data);

            function getRepId() {
                var originatorIdSections = response.originatorId.split('.');
                if(originatorIdSections.length === 2) {
                    return originatorIdSections[1]; //response.originatorId is of the form siteId.repId
                }
            }
        }

        function buildInvitationSecureFormLine(fileInfo, response) {
            response.type = lpSecureFormsController.COLLABORATION_EVENT_NAME;
            response.subType = lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM;
            response.command = lpSecureFormsController.EVENT_TYPES.SEND;
            response.args = {
                secureFormId: fileInfo.formId,
                uniqueId: fileInfo.invitationId,
                secureFormName: fileInfo.formName
            };
            response.text = agentLEManager.translateLE({key: 'LEWebAgent.' + 'secure_form_send_event_text', args: [{
                isTranslate: false,
                key: response.by
            },{
                isTranslate: false,
                key: response.args.secureFormName
            }]});
        }

        function buildSubmitSecureFormEvent(fileInfo) {
            var data = {
                events: [
                    {
                        subType: lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM,
                        command: lpSecureFormsController.EVENT_TYPES.SUBMIT,
                        args: {
                            uniqueId: fileInfo.invitationId,
                            formUuid: fileInfo.submissionId
                        }
                    }
                ]
            };
            lpTag.WebAgent.secureFormsController.onCollaborationEventHandler(data);
        }

        function buildSubmitSecureFormLine(fileInfo, response) {
            response.type = lpSecureFormsController.COLLABORATION_EVENT_NAME;
            response.subType = lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM;
            response.command = lpSecureFormsController.EVENT_TYPES.SUBMIT;
            response.args = {
                secureFormName: getSecureFormName(fileInfo),
                uniqueId: fileInfo.invitationId,
                formUuid: fileInfo.submissionId
            };
            response.text = agentLEManager.translateLE({key: 'LEWebAgent.' + 'secure_form_submit_event_text', args: [{
                isTranslate: false,
                key: response.args.secureFormName
            }]});
        }

        function getSecureFormName(fileInfo) {
            var currentSecureForm = lpTag.WebAgent.secureFormsController.getSecureFormData(fileInfo.invitationId);
            if(currentSecureForm) {
                return currentSecureForm.secureFormName;
            }
        }

        function getContentType(contentType) {
            // TODO: Add support for RichMedia.
            switch (contentType) {
                case "TEXT_PLAIN":
                    return "text/plain";
                case "HOSTED_FILE":
                    return "hosted/file";
                case "SECURE_FORM_INVITATION":
                    return "forms/secure-invitation";
                case "SECURE_FORM_SUBMIT":
                    return "forms/secure-submission";
                case "RICH_CONTENT":
                    return "richContent";
                default:
                    return;
            }
        }

        function getOriginatorId(id, by) {
            if (by === "agent") {
                return recordData.info.brandId + '.' + id;
            }
            return id;
        }

        function getAgentDeleted(line, recordData) {
            var agent = getAgentProfile(line.participantId, recordData);
            return agent && agent.agentDeleted;
        }

        function getSource(line, recordData) {
            var role, by = _.isString(line.sentBy) ? line.sentBy.toLocaleLowerCase() : '';
            if(by.toLowerCase() === "consumer") {
                return "visitor";
            } else {
                role = getAgentRole(line, recordData);
                if(role === lpTag.AMSStatics.participant.roles.CONTROLLER) {
                    return "system";
                } else {
                    return by;
                }
            }
        }

        function getStatusDictionary() {
            // TODO: Is Needed?
            var statuses = {};
            if (recordData.messageStatuses) {
                _.each(recordData.messageStatuses, function (item) {
                    var participantType = item.participantType && item.participantType.toUpperCase();
                    if (participantType !== MessagingUtils.PARTICIPANTS_ROLES.CONSUMER) {
                        return;
                    }
                    var dialogId = item.dialogId || recordData.info.conversationId;
                    var lineKey = dialogId + ':' + item.seq;

                    var oldStatus = statuses[lineKey];
                    var newStatus = item.messageDeliveryStatus;
                    if (isNewStatusUpdated(oldStatus, newStatus)) {
                        statuses[lineKey] = newStatus;
                    }
                });
            }
            return statuses;

            function isNewStatusUpdated(oldStatus, newStatus) {
                return MESSAGE_STATES_LEVELS[newStatus] && (!MESSAGE_STATES_LEVELS[oldStatus] || MESSAGE_STATES_LEVELS[oldStatus] < MESSAGE_STATES_LEVELS[newStatus]);
            }
        }

        function getActionDictionary() {
            var actions = {};
            if (recordData.messageStatuses) {
                _.each(recordData.messageStatuses, function (item) {
                    var dialogId = item.dialogId || recordData.info.conversationId;
                    var lineKey = dialogId + ':' + item.seq;
                    var status = item.messageDeliveryStatus;
                    var participantId = item.participantId;
                    var seq = item.seq;
                    if (status === 'ACTION') {
                        var lineParticipantAction = actions[lineKey] || {};
                        lineParticipantAction[participantId] = lineParticipantAction[participantId] || {};
                        lineParticipantAction[participantId].actionMessageSequenceRef = seq;
                        actions[lineKey] = lineParticipantAction;
                    }
                });
            }
            return actions;
        }
    }

    function getAgentName(agent) {
        return (agent && (agent.agentFullName || agent.agentNickname)) || "Agent";
    }

    function getConsumerObject(recordData) {
        if (recordData && recordData.consumerParticipants && recordData.consumerParticipants.length) {
            return recordData.consumerParticipants[0];
        }
    }

    function transformConsumerNameBySDEs(recordData) {
        if (recordData && recordData.consumerParticipants && recordData.consumerParticipants.length) {
            var consumerObject = recordData.consumerParticipants[0];
            if (recordData && recordData.sdes && recordData.sdes.events) {
                for (var i = 0; i < recordData.sdes.events.length; i++) {
                    var sde = recordData.sdes.events[i];
                    if (sde.sdeType === 'PERSONAL_INFO' && sde.personalInfo && sde.personalInfo.personalInfo && (sde.personalInfo.personalInfo.name || sde.personalInfo.personalInfo.surname)) {
                        consumerObject.firstName    = sde.personalInfo.personalInfo.name;
                        consumerObject.lastName     = sde.personalInfo.personalInfo.surname;
                        consumerObject.fullName     = MessagingUtils.getParticipantFullName(consumerObject.firstName, consumerObject.lastName, MessagingUtils.PARTICIPANTS_ROLES.CONSUMER, lpTag.WebAgent.logicController.enableBlockVisitorName());
                        consumerObject.consumerName = consumerObject.fullName;
                    }
                }
            }
        }
    }

    function getAssignedAgent(recordData) {
        return getAgentProfile(recordData.info.latestAgentId, recordData);
    }

    function getSuggestedAgent(recordData) {
        var lastTransfer = _.last(recordData.transfers);
        if (lastTransfer && lastTransfer.reason === 'Agent') {
            var agentProfile = getAgentProfile(lastTransfer.assignedAgentId, recordData);
            return _.assign({}, agentProfile, {
                // override group name with N/A until ums is fixed with suggested agent's group
                agentGroupName: agentLEManager.translateLE("LEWebAgent.notAvailable"),
                agentState: lpTag.AMSStatics.assignedAgentState.SUGGESTED
            });
        }
        return null;
    }

    function getAgentRole(line, recordData) {
        var agentProfile = getAgentProfile(line.participantId, recordData);
        return agentProfile && agentProfile.role;
    }

    function getAgentProfile(agentId, recordData) {
        var profile;
        _.each(recordData.agentParticipants, function (dialogParticipants) {
            if (dialogParticipants[agentId]) {
                profile = dialogParticipants[agentId];
            }
        });
        return profile;
    }

    function getSatisfactionSurvey(recordData) {
        var result = _.find(recordData.conversationSurveys, function (item) {
            return item.surveyType === 'Satisfaction' && item.surveyData.length && item.surveyData[0].answer;
        });

        if (result) {
            if (result.surveyData[0].answer === 'Yes') {
                return true;
            }
            if (result.surveyData[0].answer === 'No') {
                return false;
            }
        }
        return null;
    }

    function getAgentSummary(recordData){
       return (recordData && recordData.summary && recordData.summary.text) || '';
    }

    function getOriginContext(info) {
        var retVal = {};
        setBasicClientProperties(retVal, info);
        switch (info.source) {
            case SOURCES.SHARK: // 'Web async'
            case SOURCES.SHARK_C4M: // 'C4M'
                retVal.interactionContextId = info.interactionContextId;
                retVal.lang = info.language; //
                retVal.sessionId = info.sessionId;
                retVal.type = 'SharkContext';
                retVal.visitorId = info.visitorId;
                setAdvancedClientProperties(retVal.clientProperties, info);
                break;
            case SOURCES.APP: // 'mobile'
                retVal.lang = info.language; //
                retVal.type = 'MobileAppContext';
                setAdvancedClientProperties(retVal.clientProperties, info);
                break;
            case SOURCES.SMS:
                retVal.type = 'SMSContext';
                break;
            case SOURCES.FACEBOOK:
                retVal.type = 'FacebookContext';
                break;
            case SOURCES.GOOGLE:
            case SOURCES.APPLE:
            case SOURCES.LINE:
            case SOURCES.WHATSAPP:
            case SOURCES.WHATSAPP_BUSINESS:
            case SOURCES.WE_CHAT:
            case SOURCES.RCS_BUSINESS_MESSAGING:
                retVal.name = info.source;
                retVal.type = 'CustomContext';
                break;
            case SOURCES.AGENT: // on resume flow - currently we can't know the original source
            case SOURCES.NA:
            case SOURCES.WEB:
                break;
            default:
                // not recognized
                break;
        }
        return retVal;


        function setBasicClientProperties(retVal, info) {
            retVal.clientProperties = {
                type: '.ClientProperties',
                appId: info.appId,
                ipAddress: info.ipAddress,
                integration: info.integration,
                features: info.features
            };
        }

        function setAdvancedClientProperties(clientProperties, info) {
            clientProperties.deviceFamily = info.device;
            clientProperties.os = info.operatingSystem;
            clientProperties.osVersion = info.operatingSystemVersion;
            clientProperties.integration = info.integration;
            clientProperties.integrationVersion = info.integrationVersion;

            // 'Shark-C4M' and 'APP' only
            clientProperties.appVersion = info.appVersion;
            clientProperties.osName = info.operatingSystem;
            clientProperties.timeZone = info.timeZone;
            clientProperties.deviceModel = info.deviceModel; //

            // 'SHARK' only
            clientProperties.browser = info.browser;
            clientProperties.browserVersion = info.browserVersion;
        }
    }

    return lpMessagingEngagementHistoryTransformationHelper;

});
